export const authenticationService = {
  baseURL: 'https://api.auth.cerclex.com',
};

export const auctionService = {
  baseURL: 'https://server-auction.cerclex.com/auction',
};


export const geteWayAuctionServer = {
  baseURL: 'https://server-auction.cerclex.com',
};

;

